import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const adaptationLibraryPageWrapper = ({ theme }: { theme: Theme }) => css`
  box-sizing: border-box;
  padding: ${theme.spacing(6)} ${theme.spacing(8)};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
  flex-grow: 1;
  overflow: hidden;
`

export const adaptationLibraryWrapper = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing(4)};
  flex-wrap: wrap;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  color: #0b2948;
  align-items: flex-start;
  margin: 8px 0 0 0;
  padding-bottom: ${theme.spacing(4)};
`

export const adaptationLibraryCard = () => css`
  width: calc((100% / 3) - 12px);
  border: 1px solid #d6d6d6;
  border-radius: 8px;
  height: 300px;

  @media screen and (max-width: 1400px) {
    width: calc((100% / 2) - 16px) !important;
  }

  @media screen and (max-width: 900px) {
    width: calc((100% / 1) - 16px) !important;
  }
`

export const adaptationLibraryCardUpper = ({ theme }: { theme: Theme }) => css`
  padding: ${theme.spacing(4)};
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 200px;
`

export const adaptationLibraryCardLower = ({ theme }: { theme: Theme }) => css`
  border-top: 1px solid #d6d6d6;
  padding: ${theme.spacing(4)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  height: 100px;
`

export const adaptationLibraryCardUpperButton = () => css`
  padding: 0;
  border: unset;
  background: unset;
  cursor: pointer;
  text-align: left;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 0.8;
  }
`

export const adaptationLibraryCardBadges = () => css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
  margin-bottom: 16px;
`

export const adaptationLibraryCardBadge = ({
  theme,
  color,
  background,
}: {
  theme: Theme
  color: string
  background: string
}) => css`
  background: rgba(${color}, 0.1);
  padding: ${theme.spacing(1)} ${theme.spacing(3)};
  border-radius: 100px;
  font-size: 12px;
  color: ${color};
  background: ${background};
  font-weight: 500;
`

export const adaptationLibraryCardViewButton = () => css`
  align-self: flex-end;
`

export const adaptationLibraryFilterWrapper = () => css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: -4px;
`

export const adaptationLibrarySearchInput = () => css`
  width: 100%;

  & .MuiInputBase-root {
    border-radius: 8px;
  }

  & input {
    padding-left: 0;
  }
`

export const adaptationLibraryFilterAccordion = () => css`
  background: #f5f5f5;
  padding: 12px;
  border-radius: 8px;

  & .MuiAccordionSummary-root {
    background: #f5f5f5;
  }
`

export const adaptationLibraryDrawerWrapper = () => css`
  width: 600px;
`

export const adaptationLibraryDrawerHeader = () => css`
  border-bottom: 1px solid #d6d6d6;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #052c50;

  & > button {
    color: #0074cc;
  }

  & > button span {
    margin-right: 4px;
  }
`

export const adaptationLibraryDrawerItemWrapper = () => css`
  padding-bottom: 24px;
  padding-top 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  `

export const adaptationLibraryDrawerItem = () => css`
  font-weight: bold;
  padding-bottom: 4px;
`

export const adaptationLibraryDrawerDivider = () => css`
  padding-top: 24px;
  padding-bottom: 24px;
  border-top: 1px solid #d6d6d6;
`

export const adaptationLibraryFilterItemsWrapper = () => css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
`

export const adaptationLibraryFilterHeaderWrapper = () => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const filterAutocomplete = ({ theme }: { theme: Theme }) => css`
  position: relative;
  overflow: hidden;
  background: white;
  min-width: 300px;
  height: 39x;
  border: 1px solid #ddd;
  border-radius: 4px;

  .MuiAutocomplete-tag {
    color: ${theme.palette.primary.dark};
  }

  label.MuiFormLabel-root {
    top: -2px;
  }

  .MuiAutocomplete-inputRoot {
    flex-wrap: nowrap;
  }

  .MuiInputBase-root {
    padding: 4px !important;

    .MuiChip-root {
      border-radius: 0.2rem;
      color: ${theme.palette.primary.dark};
    }

    .MuiAutocomplete-input {
      height: 32px;
    }

    .MuiAutocomplete-clearIndicator {
      background-color: #fbfbfb;
    }

    .MuiChip-deleteIcon {
      width: 0;
      transition:
        width 0.2s ease-in-out,
        color 0.1s ease-in-out;
      color: ${theme.palette.primary.main};
    }
    :hover .MuiChip-deleteIcon {
      width: 16px;
    }

    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  }
`

export const adaptationLibraryTitle = () => css`
  color: black;
  font-size: 16px;
  margin-bottom: 16px;
  margin-top: 8px;
  font-weight: 600;
`

export const adaptationLibraryMainTitle = () => css`
  color: #0b2948;
  font-size: 16px;
  margin-bottom: 16px;
  margin-top: 8px;
  font-weight: 600;
`

export const adaptionLibraryButton = () => css`
  font-weight: semi-bold;
  font-size: 13px;
  border: 2px solid #0c98ff;
  background: rgba(0, 0, 0, 0);
  color: #0c98ff;
  font-weight: 600;
  box-shadow: unset;
  border-radius: 8px;
`

export const paginationWrapper = () => css`
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;
  margin-top: -8px;
  border-top: 1px solid #d6d6d6;
`
